/**
 * notificationsApi.ts — API client per l'inbox notifiche in-app
 *
 * Legge la tabella in_app_notifications popolata da:
 * - richieste di connessione cerchia (biker → biker)
 * - affiliazioni dealer (richiesta / approvazione / rifiuto)
 * - e altre notifiche in-app scritte dai vari flussi.
 */

import { boundApiFetch } from "@/api/core/boundApiFetch";

export interface InAppNotification {
  id: string;
  type: string;
  title: string;
  body: string;
  data: Record<string, unknown> | null;
  is_read: boolean;
  created_at: string;
}

export interface InAppNotificationsResponse {
  notifications: InAppNotification[];
  unread: number;
}

/** Lista notifiche in-app (più recenti per prime). */
export function getInAppNotifications(limit = 80): Promise<InAppNotificationsResponse> {
  return boundApiFetch<InAppNotificationsResponse>(`/api/notifications?limit=${limit}`);
}

/** Conteggio non lette (per il badge della campanella). */
export function getInAppUnreadCount(): Promise<{ unread: number }> {
  return boundApiFetch<{ unread: number }>("/api/notifications/unread-count");
}

/** Segna tutte le notifiche in-app come lette. */
export function markInAppAllRead(): Promise<{ ok: true; unread: number }> {
  return boundApiFetch<{ ok: true; unread: number }>("/api/notifications/mark-all-read", {
    method: "POST",
  });
}

/** Segna una singola notifica in-app come letta. */
export function markInAppRead(id: string): Promise<{ ok: true }> {
  return boundApiFetch<{ ok: true }>(`/api/notifications/${id}/read`, {
    method: "POST",
  });
}
